import React, { useState, useEffect } from 'react';
import { getGlobalAnalytics } from '../api';

function Dashboard() {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await getGlobalAnalytics();
      setAnalytics(response.data.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch analytics');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!analytics) {
    return null;
  }

  const handleViewAnalytics = (shortCode) => {
    window.location.hash = `#analytics/${shortCode}`;
  };

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>{analytics.summary.totalUrls}</h3>
          <p>Total URLs</p>
        </div>
        <div className="stat-card">
          <h3>{analytics.summary.totalClicks}</h3>
          <p>Total Clicks</p>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        <div className="card">
          <h3>Top URLs</h3>
          <ul className="url-list">
            {analytics.topUrls.map((url) => (
              <li key={url._id} className="url-item">
                <div className="url-item-info">
                  <h4>{url.title || url.shortCode}</h4>
                  <p style={{ fontSize: '0.9rem' }}>{url.originalUrl}</p>
                </div>
                <div className="url-item-stats">
                  <p><strong>{url.totalClicks}</strong></p>
                  <p style={{ fontSize: '0.8rem' }}>clicks</p>
                </div>
                <div className="url-item-actions">
                  <button
                    onClick={() => handleViewAnalytics(url.shortCode)}
                    className="btn"
                  >
                    View
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="card">
          <h3>Recent URLs</h3>
          <ul className="url-list">
            {analytics.recentUrls.map((url) => (
              <li key={url._id} className="url-item">
                <div className="url-item-info">
                  <h4>{url.title || url.shortCode}</h4>
                  <p style={{ fontSize: '0.9rem' }}>{url.originalUrl}</p>
                  <p style={{ fontSize: '0.8rem', color: '#7f8c8d', marginTop: '5px' }}>
                    {new Date(url.createdAt).toLocaleDateString()}
                  </p>
                </div>
                <div className="url-item-stats">
                  <p><strong>{url.totalClicks}</strong></p>
                  <p style={{ fontSize: '0.8rem' }}>clicks</p>
                </div>
                <div className="url-item-actions">
                  <button
                    onClick={() => handleViewAnalytics(url.shortCode)}
                    className="btn"
                  >
                    View
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
